import { Box, Typography, Button, Chip } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { useState } from "react";

export default function FileUploadBox({
  selectedFile,
  onFileSelect,
  accept,
  placeholder = "Seleccionar archivo",
  helperText = "O arrastrá y soltá el archivo aquí",
}) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) onFileSelect(file);
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    if (file) onFileSelect(file);
  };

  return (
    <Box
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      sx={{
        border: isDragging
          ? "2px dashed #1976d2"
          : "2px dashed rgba(0,0,0,0.15)",
        borderRadius: 3,
        p: 4,
        textAlign: "center",
        bgcolor: isDragging
          ? "rgba(25, 118, 210, 0.05)"
          : selectedFile
            ? "rgba(46,125,50,0.05)"
            : "transparent",
        transition: "all 0.2s ease",
      }}
    >
      <input
        type="file"
        hidden
        accept={accept}
        onChange={handleInputChange}
        id="file-upload-input"
      />
      <label htmlFor="file-upload-input">
        <Button
          component="span"
          variant="outlined"
          startIcon={<CloudUploadOutlinedIcon />}
          sx={{
            borderRadius: 2.5,
            fontWeight: 800,
            textTransform: "none",
            mb: 2,
          }}
        >
          {placeholder}
        </Button>
      </label>

      {selectedFile ? (
        <Box>
          <Chip
            label={selectedFile.name}
            color="success"
            variant="outlined"
            sx={{ fontWeight: 700 }}
          />
        </Box>
      ) : (
        <Typography variant="body2" sx={{ opacity: 0.6 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
